module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-hover-last-ba70611669b351257fedab9368d4ad6b.svg";